import type { GQL_ID } from '@@partner:types:graphql'
import type {
  CategoriesBranchQuery,
  CategoriesBranchQueryVariables
} from './graphql'

import React, { useState, useCallback, useMemo } from 'react'
import { useQuery } from '@apollo/client'

import { TreePicker } from 'rsuite'
import AppLoader from '@components/common/AppLoader'

import { GQL_QUERY_CATEGORIES_BRANCH } from './graphql'

export interface ProductSearchCategoryFilterProps {
  id?: string
  value?: GQL_ID
  shop_id: GQL_ID
  onChange: (v: any) => void
}

export default function ProductSearchCategoryFilter ({
  id,
  value,
  shop_id,
  onChange
}: ProductSearchCategoryFilterProps) {
  const [ selectedCategoryId, setSelectedCategoryId ] = useState(value)

  const { data, loading, fetchMore } = useQuery<
    CategoriesBranchQuery,
    CategoriesBranchQueryVariables
  >(GQL_QUERY_CATEGORIES_BRANCH, {
    variables: {
      shop_id
    }
  })

  /*
    Normalize gql response
  */

  const categories = useMemo(() => {
    if (data?.categoriesBranch) {
      return data.categoriesBranch.map((branch) => ({
        id: branch.id,
        name: branch.name,
        childrens:
          branch.childrens?.map((branch) => ({
            id: branch.id,
            name: branch.name
          })) ?? []
      }))
    }
    else {
      return []
    }
  }, [ data ])

  const handleChange = useCallback(
    (value: any) => {
      setSelectedCategoryId(value)
      onChange(value)
    },
    [ onChange ]
  )

  const handleOnExpand = useCallback(
    (_expandItemValues: any, activeNode: any, _concat: any) => {
      const { id } = activeNode

      /*
        Load childrens
      */

      if (activeNode.childrens.length === 0) {
        fetchMore({
          variables: {
            parent_id: id
          },
          updateQuery: (
            previousResult: any = {},
            { fetchMoreResult = {} }: any
          ) => {
            const childrens = fetchMoreResult?.categoriesBranch ?? []
            return {
              ...previousResult,
              categoriesBranch: previousResult.categoriesBranch.map(
                (branch: any) => {
                  if (branch.id === id) {
                    return {
                      ...branch,
                      childrens
                    }
                  }
                  return branch
                }
              )
            }
          }
        })
      }
    },
    [ fetchMore ]
  )

  if (loading) {
    return <AppLoader.Inline content="Загрузка категорий" />
  }

  return (
    <TreePicker
      id={id}
      size="xs"
      data={categories}
      onChange={handleChange}
      value={selectedCategoryId}
      onExpand={handleOnExpand}
      valueKey={'id'}
      labelKey={'name'}
      childrenKey={'childrens'}
      searchable={false}
      placeholder="Категория не выбрана"
      block
    />
  )
}
